import { SVGProps } from 'react';

const Split = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 8V3h-5m5 0-6 6M3 8V3h5M3 3l7.828 7.828A4 4 0 0 1 12 13.7V22"
    />
  </svg>
);
export default Split;
